import { combineStrings } from 'assets/utils/data/String';
import parseJwt from 'assets/utils/parsersAndValidation/Parsers';

export enum AuthPermission {
  createRole = 'CREATE_ROLE',
  editRole = 'EDIT_ROLE',
  deleteRole = 'DELETE_ROLE',
  viewPermission = 'VIEW_PERMISSION',
  createUser = 'CREATE_USER',
  editUser = 'EDIT_USER',
  deleteUser = 'DELETE_USER',
  resetPassword = 'RESET_PASSWORD',
  viewAccessLogs = 'VIEW_ACCESSLOGS',
  viewAuditLogs = 'VIEW_AUDITLOGS',
  viewCategory = 'VIEW_CATEGORY',
  viewApplication = 'VIEW_APPLICATION',
  createProduct = 'CREATE_PRODUCT',
  editProduct = 'EDIT_PRODUCT',
  editProductTax = 'EDIT_PRODUCTTAX',
  deleteProduct = 'DELETE_PRODUCT',
  createContract = 'CREATE_CONTRACT',
  uploadDocumentContract = 'UPLOAD_DOCUMENTS_CONTRACT',
  editContract = 'EDIT_CONTRACT',
  editContractUnrestricted = 'EDIT_CONTRACT_UNRESTRICTED',
  updateContractStatusUnrestricted = 'UPDATE_CONTRACT_STATUS_UNRESTRICTED',
  editContractComment = 'EDIT_CONTRACTCOMMENT',
  deleteContractComment = 'DELETE_CONTRACTCOMMENT',
  viewContractComment = 'VIEW_CONTRACTCOMMENT',
  viewContractLogs = 'VIEW_CONTRACT_LOGS',
  vertaforeSyncContract = 'VERTAFORE_SYNC_CONTRACT',
  deleteContract = 'DELETE_CONTRACT',
  changeContractCreator = 'CHANGE_CONTRACT_CREATOR',
  sendContractForSigning = 'SEND_CONTRACT_FOR_SIGNING',
  reuploadSignedContractDocument = 'REUPLOAD_SIGNED_CONTRACTDOCUMENT',
  createEmailTemplate = 'CREATE_EMAILTEMPLATE',
  editEmailTemplate = 'EDIT_EMAILTEMPLATE',
  deleteEmailTemplate = 'DELETE_EMAILTEMPLATE',
  createVehicleModel = 'CREATE_VEHICLEMODEL',
  editVehicleModel = 'EDIT_VEHICLEMODEL',
  deleteVehicleModel = 'DELETE_VEHICLEMODEL',
  createVehicleMake = 'CREATE_VEHICLEMAKE',
  editVehicleMake = 'EDIT_VEHICLEMAKE',
  deleteVehicleMake = 'DELETE_VEHICLEMAKE',
  importVehicleMakeFromExcel = 'IMPORT_VEHICLEMAKE_FROM_EXCEL',
  createVehicleClass = 'CREATE_VEHICLECLASS',
  editVehicleClass = 'EDIT_VEHICLECLASS',
  deleteVehicleClass = 'DELETE_VEHICLECLASS',
  createTier = 'CREATE_TIER',
  editTier = 'EDIT_TIER',
  deleteTier = 'DELETE_TIER',
  createLender = 'CREATE_LENDER',
  editLender = 'EDIT_LENDER',
  deleteLender = 'DELETE_LENDER',
  createInsurer = 'CREATE_INSURER',
  editInsurer = 'EDIT_INSURER',
  deleteInsurer = 'DELETE_INSURER',
  createSubfee = 'CREATE_SUBFEE',
  editSubfee = 'EDIT_SUBFEE',
  deleteSubfee = 'DELETE_SUBFEE',
  createProvider = 'CREATE_PROVIDER',
  editProvider = 'EDIT_PROVIDER',
  deleteProvider = 'DELETE_PROVIDER',

  //#region Product Pricing Permissions
  viewProductClassPricePoint = 'VIEW_PRODUCTPRICINGPLAN',
  createProductClassPricePoint = 'CREATE_PRODUCTPRICINGPLAN',
  editProductClassPricePoint = 'EDIT_PRODUCTPRICINGPLAN',
  deleteProductClassPricePoint = 'DELETE_PRODUCTPRICINGPLAN',

  viewProductCustomPricePoint = 'VIEW_CUSTOMPRICEPOINT',
  createProductCustomPricePoint = 'CREATE_CUSTOMPRICEPOINT',
  editProductCustomPricePoint = 'EDIT_CUSTOMPRICEPOINT',
  deleteProductCustomPricePoint = 'DELETE_CUSTOMPRICEPOINT',

  viewProductNonWarrantyPricePoint = 'VIEW_NONWARRANTYPRICEPOINT',
  createProductNonWarrantyPricePoint = 'CREATE_NONWARRANTYPRICEPOINT',
  editProductNonWarrantyPricePoint = 'EDIT_NONWARRANTYPRICEPOINT',
  deleteProductNonWarrantyPricePoint = 'DELETE_NONWARRANTYPRICEPOINT',

  viewProductTierPricePoint = 'VIEW_PRODUCTTIERPRICEPOINT',
  createProductTierPricePoint = 'CREATE_PRODUCTTIERPRICEPOINT',
  editProductTierPricePoint = 'EDIT_PRODUCTTIERPRICEPOINT',
  deleteProductTierPricePoint = 'DELETE_PRODUCTTIERPRICEPOINT',
  //#endregion

  createPricingLimitTemplate = 'CREATE_PRICINGLIMITTEMPLATE',
  editPricingLimitTemplate = 'EDIT_PRICINGLIMITTEMPLATE',
  deletePricingLimitTemplate = 'DELETE_PRICINGLIMITTEMPLATE',
  createPricingDistributionTemplate = 'CREATE_PRICINGDISTRIBUTIONTEMPLATE',
  editPricingDistributionTemplate = 'EDIT_PRICINGDISTRIBUTIONTEMPLATE',
  deletePricingDistributionTemplate = 'DELETE_PRICINGDISTRIBUTIONTEMPLATE',

  impersonateDistributorsUser = 'IMPERSONATE_DISTRIBUTORS_USER',
  deleteDistributor = 'DELETE_DISTRIBUTOR',
  editDistributor = 'EDIT_DISTRIBUTOR',
  createDistributor = 'CREATE_DISTRIBUTOR',
  deleteDealer = 'DELETE_DEALER',
  editDealer = 'EDIT_DEALER',
  createDealer = 'CREATE_DEALER',
  deleteDealerGroup = 'DELETE_DEALERGROUP',
  editDealerGroup = 'EDIT_DEALERGROUP',
  createDealerGroup = 'CREATE_DEALERGROUP',

  createStatement = 'CREATE_STATEMENT',
  editStatement = 'EDIT_STATEMENT',
  deleteStatement = 'DELETE_STATEMENT',
  modifyStatementEmail = 'MODIFY_STATEMENT_EMAIL',
  updateStatementStatus = 'UPDATE_STATEMENT_STATUS',
  updateContractStatus = 'UPDATE_CONTRACT_STATUS',

  createStatementBalance = 'CREATE_STATEMENTBALANCE',
  editStatementBalance = 'EDIT_STATEMENTBALANCE',
  deleteStatementBalance = 'DELETE_STATEMENTBALANCE',
  modifyStatementBalanceEmail = 'MODIFY_STATEMENTBALANCE_EMAIL',

  createStatementSummary = 'CREATE_STATEMENTSUMMARY',
  deleteStatementSummary = 'DELETE_STATEMENTSUMMARY',

  //#region Claims Permissions
  createClaim = 'CREATE_CLAIM',
  createSimpleClaim = 'CREATE_SIMPLE_CLAIM',
  createClaimForExpiredContract = 'CREATE_CLAIM_FOR_EXPIRED_CONTRACT',
  editClaim = 'EDIT_CLAIM',
  deleteClaim = 'DELETE_CLAIM',
  updateClaimStatus = 'UPDATE_CLAIM_STATUS',
  updateClaimOwner = 'UPDATE_CLAIM_OWNER',
  viewClaimHistory = 'VIEW_CLAIM_HISTORY',
  editClaimCustomerInfo = 'EDIT_CLAIM_CUSTOMERINFO',
  viewClaimCustomerInfo = 'VIEW_CLAIM_CUSTOMERINFO',
  viewOnlyOwnedClaims = 'VIEW_ONLY_OWNED_CLAIMS',
  viewClaimPayee = 'VIEW_CLAIMPAYEE',
  editClaimPayee = 'EDIT_CLAIMPAYEE',
  viewClaimVehicleInfo = 'VIEW_CLAIM_VEHICLEINFO',
  viewClaimContractInfo = 'VIEW_CLAIM_CONTRACTINFO',
  createClaimJob = 'CREATE_CLAIMJOB',
  editClaimJob = 'EDIT_CLAIMJOB',
  deleteClaimJob = 'DELETE_CLAIMJOB',
  updateClaimJobStatus = 'UPDATE_CLAIMJOB_STATUS',
  viewClaimJobItem = 'VIEW_CLAIMJOBITEM',
  createClaimJobItem = 'CREATE_CLAIMJOBITEM',
  editClaimJobItem = 'EDIT_CLAIMJOBITEM',
  deleteClaimJobItem = 'DELETE_CLAIMJOBITEM',
  viewClaimJobComment = 'VIEW_CLAIMJOBCOMMENT',
  createClaimJobComment = 'CREATE_CLAIMJOBCOMMENT',
  editClaimJobComment = 'EDIT_CLAIMJOBCOMMENT',
  deleteClaimJobComment = 'DELETE_CLAIMJOBCOMMENT',
  viewClaimJobDocument = 'VIEW_CLAIMJOBDOCUMENT',
  uploadClaimJobDocument = 'UPLOAD_CLAIMJOBDOCUMENT',
  downloadClaimJobDocument = 'DOWNLOAD_CLAIMJOBDOCUMENT',
  deleteClaimJobDocument = 'DELETE_CLAIMJOBDOCUMENT',
  viewClaimDocument = 'VIEW_CLAIMDOCUMENT',
  uploadClaimDocument = 'UPLOAD_CLAIMDOCUMENT',
  downloadClaimDocument = 'DOWNLOAD_CLAIMDOCUMENT',
  deleteClaimDocument = 'DELETE_CLAIMDOCUMENT',
  downloadAllClaimDocument = 'DOWNLOAD_AllCLAIMDOCUMENT',
  viewClaimInvoice = 'VIEW_CLAIMINVOICE',
  uploadClaimInvoice = 'UPLOAD_CLAIMINVOICE',
  downloadClaimInvoice = 'DOWNLOAD_CLAIMINVOICE',
  deleteClaimInvoice = 'DELETE_CLAIMINVOICE',
  sendClaimEmail = 'SEND_CLAIMEMAIL',
  viewClaimEmailHistory = 'VIEW_CLAIMEMAIL_HISTORY',
  viewClaimLogs = 'VIEW_CLAIM_LOGS',
  createClaimType = 'CREATE_CLAIMTYPE',
  editClaimType = 'EDIT_CLAIMTYPE',
  deleteClaimType = 'DELETE_CLAIMTYPE',
  createLossCode = 'CREATE_LOSSCODE',
  editLossCode = 'EDIT_LOSSCODE',
  deleteLossCode = 'DELETE_LOSSCODE',
  claimAdmin = 'CLAIM_ADMIN',
  createPayee = 'CREATE_PAYEE',
  editPayee = 'EDIT_PAYEE',
  deletePayee = 'DELETE_PAYEE',
  viewInternalClaimComment = 'VIEW_INTERNAL_CLAIM_COMMENT',
  createInternalClaimComment = 'CREATE_INTERNAL_CLAIM_COMMENT',
  editInternalClaimComment = 'EDIT_INTERNAL_CLAIM_COMMENT',
  deleteInternalClaimComment = 'DELETE_INTERNAL_CLAIM_COMMENT',
  viewExternalClaimComment = 'VIEW_EXTERNAL_CLAIM_COMMENT',
  createExternalClaimComment = 'CREATE_EXTERNAL_CLAIM_COMMENT',
  editExternalClaimComment = 'EDIT_EXTERNAL_CLAIM_COMMENT',
  deleteExternalClaimComment = 'DELETE_EXTERNAL_CLAIM_COMMENT',
  importLossCode = 'IMPORT_LOSSCODE',
  modifyClaimJobUsBankPayment = 'MODIFY_CLAIMJOB_USBANK_PAYMENT',
  cancelClaimJobUsBankPayment = 'CANCEL_CLAIMJOB_USBANK_PAYMENT',
  //#endregion
}
export type VerifyPermission = Utils.VerifyExtends<Auth.Permission, Utils.ValueOf<typeof AuthPermission>>;

export const claimsPermissions = [
  AuthPermission.createClaim,
  AuthPermission.createSimpleClaim,
  AuthPermission.createClaimForExpiredContract,
  AuthPermission.editClaim,
  AuthPermission.deleteClaim,
  AuthPermission.updateClaimStatus,
  AuthPermission.updateClaimOwner,
  AuthPermission.viewClaimHistory,
  AuthPermission.editClaimCustomerInfo,
  AuthPermission.viewClaimCustomerInfo,
  AuthPermission.viewClaimPayee,
  AuthPermission.editClaimPayee,
  AuthPermission.viewClaimVehicleInfo,
  AuthPermission.viewClaimContractInfo,
  AuthPermission.createClaimJob,
  AuthPermission.editClaimJob,
  AuthPermission.deleteClaimJob,
  AuthPermission.updateClaimJobStatus,
  AuthPermission.viewClaimJobItem,
  AuthPermission.createClaimJobItem,
  AuthPermission.editClaimJobItem,
  AuthPermission.deleteClaimJobItem,
  AuthPermission.viewClaimJobComment,
  AuthPermission.createClaimJobComment,
  AuthPermission.editClaimJobComment,
  AuthPermission.deleteClaimJobComment,
  AuthPermission.viewClaimJobDocument,
  AuthPermission.uploadClaimJobDocument,
  AuthPermission.downloadClaimJobDocument,
  AuthPermission.deleteClaimJobDocument,
  AuthPermission.viewClaimDocument,
  AuthPermission.uploadClaimDocument,
  AuthPermission.downloadClaimDocument,
  AuthPermission.deleteClaimDocument,
  AuthPermission.downloadAllClaimDocument,
  AuthPermission.viewClaimInvoice,
  AuthPermission.uploadClaimInvoice,
  AuthPermission.downloadClaimInvoice,
  AuthPermission.deleteClaimInvoice,
  AuthPermission.sendClaimEmail,
  AuthPermission.viewClaimEmailHistory,
  AuthPermission.viewClaimLogs,
  AuthPermission.claimAdmin,
  AuthPermission.viewInternalClaimComment,
  AuthPermission.createInternalClaimComment,
  AuthPermission.editInternalClaimComment,
  AuthPermission.deleteInternalClaimComment,
  AuthPermission.viewExternalClaimComment,
  AuthPermission.createExternalClaimComment,
  AuthPermission.editExternalClaimComment,
  AuthPermission.deleteExternalClaimComment,
  AuthPermission.modifyClaimJobUsBankPayment,
  AuthPermission.cancelClaimJobUsBankPayment,
  AuthPermission.viewOnlyOwnedClaims,
];

const authTokenSessionKey = 'token';
export function getAuthToken() {
  return localStorage.getItem(authTokenSessionKey);
}
export function setAuthToken(token?: string) {
  if (!token) localStorage.removeItem(authTokenSessionKey);
  else localStorage.setItem(authTokenSessionKey, token);
}
export function unpackToken(data: string) {
  const tokenUnpacked = parseJwt<Api.TokenUnpacked>(data);
  return !tokenUnpacked
    ? {}
    : {
        token: data,
        userId: parseInt(tokenUnpacked.UserId),
        expirationTimestamp: tokenUnpacked.exp,
        displayname: combineStrings(' ', tokenUnpacked.family_name, tokenUnpacked.given_name),
        familyName: tokenUnpacked.family_name,
        givenName: tokenUnpacked.given_name,
        language: tokenUnpacked.ContentLanguage,
        email:
          tokenUnpacked.email || tokenUnpacked['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'],
        permissions: tokenUnpacked.Premission
          ? Array.isArray(tokenUnpacked.Premission)
            ? tokenUnpacked.Premission.reduce((prev, curr) => ({ ...prev, [curr]: true }), {})
            : { [tokenUnpacked.Premission]: true }
          : {},
      };
}
